"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchMetricsSchema = void 0;
var react_1 = require("react");
var ai_hub_elements_api_service_1 = require("../../shared/services/ai-hub-elements-api.service");
var metrics_api_mapping_1 = require("../utils/metrics-api-mapping");
var use_metrics_draft_schema_1 = require("./use-metrics-draft-schema");
var EMPTY_SCHEMA = [];
/**
 * Higher-level wrapper around {@link useMetricsDraftSchema} that
 * sources the initial schema from the AI Hub elements API and
 * persists local changes back to it. Exposes the same draft-state
 * API plus loading / saving / refresh affordances so the existing
 * Metrics view component only needs minimal changes.
 *
 * @param elementType - Backend element type to load (e.g. 'metric').
 */
exports.useFetchMetricsSchema = function (elementType, opts) {
    var _a = react_1.useState(EMPTY_SCHEMA), initialSchema = _a[0], setInitialSchema = _a[1];
    var _b = react_1.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = react_1.useState(false), isSaving = _c[0], setIsSaving = _c[1];
    var _d = react_1.useState(null), apiError = _d[0], setApiError = _d[1];
    var _e = react_1.useState(0), reloadKey = _e[0], setReloadKey = _e[1];
    var draftApi = use_metrics_draft_schema_1.useMetricsDraftSchema(initialSchema);
    // Wire fetch → initial schema. A reload is triggered either by a
    // type switch or by an explicit `refresh()` call (see below).
    react_1.useEffect(function () {
        var cancelled = false;
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, groups, elements, schema, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Clear stale data immediately so a tab switch doesn't briefly
                        // render the previous element type's rows before the new fetch
                        // resolves.
                        setInitialSchema(EMPTY_SCHEMA);
                        setIsLoading(true);
                        setApiError(null);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all([
                                ai_hub_elements_api_service_1.fetchElementGroupsForType(elementType),
                                ai_hub_elements_api_service_1.fetchAllElementsForType(elementType, { includeInactive: opts === null || opts === void 0 ? void 0 : opts.includeInactive }),
                            ])];
                    case 2:
                        _a = _b.sent(), groups = _a[0], elements = _a[1];
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        schema = metrics_api_mapping_1.buildMetricsSchemaFromApi(groups, elements);
                        setInitialSchema(schema);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        if (!cancelled) {
                            setApiError(error_1 instanceof Error ? error_1.message : String(error_1));
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (!cancelled) {
                            setIsLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void run();
        return function () {
            cancelled = true;
        };
    }, [elementType, opts === null || opts === void 0 ? void 0 : opts.includeInactive, reloadKey]);
    var refresh = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setReloadKey(function (current) { return current + 1; });
            return [2 /*return*/];
        });
    }); }, []);
    var saveChangesAsync = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var plan, draftToBackendId, _i, _a, create, created, _b, _c, rename, _d, _e, move, targetGroupId, _f, _g, groupId, error_2;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    setApiError(null);
                    setIsSaving(true);
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 18, 19, 20]);
                    plan = metrics_api_mapping_1.planMetricsSchemaDiff(draftApi.draftSchema, draftApi.savedSchema);
                    draftToBackendId = new Map();
                    _i = 0, _a = plan.groupsToCreate;
                    _h.label = 2;
                case 2:
                    if (!(_i < _a.length)) return [3 /*break*/, 5];
                    create = _a[_i];
                    return [4 /*yield*/, ai_hub_elements_api_service_1.createElementGroup({
                            type: elementType,
                            name: create.name,
                        })];
                case 3:
                    created = _h.sent();
                    draftToBackendId.set(create.draftCategoryId, created.id);
                    _h.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    _b = 0, _c = plan.groupsToRename;
                    _h.label = 6;
                case 6:
                    if (!(_b < _c.length)) return [3 /*break*/, 9];
                    rename = _c[_b];
                    return [4 /*yield*/, ai_hub_elements_api_service_1.updateElementGroup(rename.groupId, { name: rename.name })];
                case 7:
                    _h.sent();
                    _h.label = 8;
                case 8:
                    _b++;
                    return [3 /*break*/, 6];
                case 9:
                    _d = 0, _e = plan.elementMoves;
                    _h.label = 10;
                case 10:
                    if (!(_d < _e.length)) return [3 /*break*/, 13];
                    move = _e[_d];
                    targetGroupId = metrics_api_mapping_1.resolveGroupIdForCategory(move.targetCategoryId, draftToBackendId);
                    if (targetGroupId === undefined) {
                        // Moving into a draft category that failed to materialise on
                        // the backend. Skip the move; the next refresh will surface
                        // the discrepancy to the admin.
                        return [3 /*break*/, 12];
                    }
                    return [4 /*yield*/, ai_hub_elements_api_service_1.setElementGroup(move.elementId, targetGroupId)];
                case 11:
                    _h.sent();
                    _h.label = 12;
                case 12:
                    _d++;
                    return [3 /*break*/, 10];
                case 13:
                    _f = 0, _g = plan.groupsToDelete;
                    _h.label = 14;
                case 14:
                    if (!(_f < _g.length)) return [3 /*break*/, 17];
                    groupId = _g[_f];
                    return [4 /*yield*/, ai_hub_elements_api_service_1.deleteElementGroup(groupId)];
                case 15:
                    _h.sent();
                    _h.label = 16;
                case 16:
                    _f++;
                    return [3 /*break*/, 14];
                case 17:
                    // 5. Re-fetch authoritative server state and rebase the saved/draft
                    //    snapshots so locally generated draft ids are replaced by real
                    //    ones and orphans are reconciled.
                    setReloadKey(function (current) { return current + 1; });
                    return [3 /*break*/, 20];
                case 18:
                    error_2 = _h.sent();
                    setApiError(error_2 instanceof Error ? error_2.message : String(error_2));
                    throw error_2;
                case 19:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 20: return [2 /*return*/];
            }
        });
    }); }, [draftApi.draftSchema, draftApi.savedSchema, elementType]);
    return react_1.useMemo(function () { return (__assign(__assign({}, draftApi), { elementType: elementType,
        isLoading: isLoading,
        isSaving: isSaving,
        apiError: apiError,
        refresh: refresh,
        saveChangesAsync: saveChangesAsync })); }, [draftApi, elementType, isLoading, isSaving, apiError, refresh, saveChangesAsync]);
};
